export function parseServerTime(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  const raw = String(value);
  const date = new Date(/[TZ]/.test(raw) ? raw : `${raw.replace(' ', 'T')}Z`);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDuration(startTime, resolvedAt) {
  if (!resolvedAt) return 'Ongoing';

  const minutes = Math.round((new Date(resolvedAt) - new Date(startTime)) / 60000);

  if (minutes < 60) return `${minutes}m`;
  if (minutes < 1440) return `${Math.round(minutes / 60)}h`;
  return `${Math.round(minutes / 1440)}d`;
}

// Decimal units (1 GB = 10^9 bytes), matching how disk sizes are quoted.
export function formatBytes(bytes, fractionDigits = 2) {
  const value = Number(bytes);
  if (!Number.isFinite(value) || value < 0) return '-';
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  let size = value;
  let unit = 0;
  while (size >= 1000 && unit < units.length - 1) {
    size /= 1000;
    unit += 1;
  }
  return `${unit === 0 ? size : size.toFixed(fractionDigits)} ${units[unit]}`;
}

export function formatResponseTime(ms) {
  if (ms == null || Number.isNaN(Number(ms))) return '-';
  return `${Math.round(Number(ms))}ms`;
}

export function formatPercent(value, fixed = 2) {
  if (value == null || Number.isNaN(Number(value))) return '-';
  return `${Number(value).toFixed(fixed)}%`;
}
